let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4RcLg"), load("15VrD"), load("6wr18"), load("ffEVr"), load("4Kqu1")]).then(() => parcelRequire('i6jK3'));